import React from "react";
import Sticky from "react-stickynode";
import * as zenscroll from "zenscroll";
import { isBrowser } from "../../../../../core/detection";
import { ResponsiveBreakpoints } from "../../../../../../../packages/ui/src/utils/uiHelpers";
import { useWindowDimensions } from "../../../../../core/atoms";
import { NavMenuItem } from "../../../../components/navMenu/navMenu";
import { PageScrollNav } from "../../../../components/navMenu/pageScrollNav";
import { RouteNav } from "../../../../components/navMenu/routeNav";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./menu.scss";

interface AboutMenuProps {
  overview: boolean;
}

export const AboutMenu: React.FC<AboutMenuProps> = (props: AboutMenuProps) => {
  const { width } = useWindowDimensions();
  const isMobile = width < ResponsiveBreakpoints.tablet;
  const items: NavMenuItem[] =
    [{
      label: "Overview",
      id: "about-section-overview",
      slug: "overview",
    },
    {
      label: "Our Story",
      id: "about-section-story",
      slug: "our-story",
    },
    {
      label: "How it works",
      id: "about-section-works",
      slug: "how-it-works",
    },
    {
      label: "Meet the team",
      id: "about-section-team",
      slug: "meet-the-team",
      relatedPage: WebRoutes.aboutMeetTheTeam(),
    },
    {
      label: "Our local experts",
      id: "about-section-experts",
      slug: "our-local-experts",
    }];

  if (!isBrowser() || isBrowser() && isMobile) {
    return null;
  }

  zenscroll.setup(null, 65); // This is used offset the scrolling stopping point, so content is not hidden behind the main site nav

  return (
    <div className="about-menu">
      <Sticky
        enabled={!isMobile}
        innerZ={5}
        top={114} // 74 size of site nav + 40
        bottomBoundary=".about-bottom-boundary"
      >
        {props.overview ?
          (
            <PageScrollNav
              items={items}
              onItemClick={(id) => zenscroll.to(document.querySelector(`[data-scroll-id="${id}"]`))}
            />
          ) : (
            <RouteNav
              items={items}
              baseRoute={WebRoutes.aboutHome()}
            />
          )
        }
      </Sticky>
    </div>
  );
};
